import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getFormattedDate } from '../functions/get-formatted-date';
import { WorkAbsenceDayPartEnum } from '@work-frontend-monorepo/work-rest-api';

export interface AbsenceLikeDateRange {
  start: string | Date | null;
  end: string | Date | null;
  dayPart?: WorkAbsenceDayPartEnum | null;
}

@Pipe({
  name: 'formatAbsenceDateRange',
  standalone: true,
})
export class FormatAbsenceDateRangePipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(absence: AbsenceLikeDateRange | null | undefined): string {
    if (!absence || !absence.start) {
      return '';
    }
    const startFormatted = getFormattedDate(absence.start, 'DD.MM.YYYY');
    const endFormatted = absence.end ? getFormattedDate(absence.end, 'DD.MM.YYYY') : startFormatted;
    const isSingleDay = startFormatted === endFormatted;
    const dayPart = absence.dayPart ?? WorkAbsenceDayPartEnum.Full;

    if (dayPart === WorkAbsenceDayPartEnum.Full) {
      return isSingleDay ? startFormatted : `${startFormatted} – ${endFormatted}`;
    }

    if (isSingleDay) {
      const suffixKey = dayPart === WorkAbsenceDayPartEnum.Morning ? 'VORMITTAG' : 'NACHMITTAG';
      return `${startFormatted}, ${this.translateService.instant(suffixKey)}`;
    }

    const suffixKey = dayPart === WorkAbsenceDayPartEnum.Morning ? 'VORMITTAGE' : 'NACHMITTAGE';
    return `${startFormatted} – ${endFormatted}, ${this.translateService.instant(suffixKey)}`;
  }
}
